import { combineReducers } from "redux";
import taskReducer from "./taskReducer";

const rootReducer = combineReducers({
  records: taskReducer,
});

export default rootReducer;
